export const brand = {
  universeName: '[NOMBRE_DE_LA_MACROSAGA]',
  universeSuffix: 'Chronicles',
  archiveName: 'Biblioteca de Cárdinal Terminus',
  authorName: 'MagicalRaven',
  locale: 'es-MX',
  activeBook: {
    id: 'yuna-echoes-of-rhem',
    title: 'Yuna: Echoes of Rhem',
    saga: 'Yuna',
    status: 'campaign' as const,
    amazonUrl: null as string | null,
    releaseDate: null as string | null,
  },
  copy: {
    homeEyebrow: 'Registro vivo · Archivo 01',
    homeTitle: 'Toda historia deja un eco.',
    homeLead:
      'Más allá del último índice, una memoria imposible ha vuelto a respirar. La Biblioteca te reconoce.',
    yunaSynopsis:
      'Cuando unas joyas de incalculable valor son robadas, Yuna y Valerius emprenden una aventura para recuperarlas. Sin embargo, lo que parecía una simple búsqueda pronto revela una conspiración capaz de sacudir Nilwind y provocar la caída de su gran capital.',
  },
} as const;

export type BrandConfig = typeof brand;
